import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';

const service = {

  async getAssignmentList(params) {
    const endPoint = `assignments/getAssignmentList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getAssignmentById(params) {
    const endPoint = `assignments/getById?id=${params.id}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveAssignment(payload) {
    const endPoint = 'assignments/save';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteAssignment(params) {
    const endPoint = `assignments/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateAssignment(payload) {
    const endPoint = `assignments/updateAssignment?assignmentId=${payload.assignmentId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getAllUser() {
    const endPoint = `user/getAllUser`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getAllDevice() {
    const endPoint = `device/getAllDevices`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getAllProduct() {
    const endPoint = `product/getAll`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getAllCompany() {
    const endPoint = `company/getAll`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async getAssignmentsWithSearch(params) {
    const endPoint = `assignments/findAssignmentSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getCompanyWithSearch(params) {
    const endPoint = `company/findCompanySearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getDevicesWithSearch(params) {
    const endPoint = `device/findDeviceSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getProductWithSearch(params) {
    const endPoint = `product/findProductSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getSimcardsWithSearch(params) {
    const endPoint = `simCard/findSimCardSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getSimCardDeviceWithSearch(params) {
    const endPoint = `simCardDevice/findSimCardDeviceSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getUserWithSearch(params) {
    const endPoint = `user/findUserSearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },
};

export default service;
